import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MijnTokensBrowserModule } from './mijn-tokens-browser.module';

registerLocaleData(localeNl, 'nl');

// @ts-ignore: Needs to be ignored so the typescript compiler replaces CONFIGURATION
export const configuration: string = CONFIGURATION;

if (configuration !== 'development') {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(MijnTokensBrowserModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch((err) => console.error(err)); //NOSONAR
